// Interface for the function's parameters for type safety
interface DropdownPathProps {
    width: number
    totalHeight: number
    caretHeight: number
    caretWidth: number
    caretPosition: number
    borderRadius: number
}

export const generateDropdownClipPath = ({
    width,
    totalHeight,
    caretHeight,
    caretWidth,
    caretPosition,
    borderRadius: r,
}: DropdownPathProps): string => {
    const exactCaretPosition = caretPosition
    const pathData = [
        `M ${r} ${caretHeight}`, // Start after top-left corner
        `L ${exactCaretPosition - caretWidth / 2} ${caretHeight}`, // Line to caret base left
        `L ${exactCaretPosition} 0`, // Line to caret tip
        `L ${exactCaretPosition + caretWidth / 2} ${caretHeight}`, // Line to caret base right
        `L ${width - r} ${caretHeight}`, // Line to top-right corner start
        `A ${r} ${r} 0 0 1 ${width} ${caretHeight + r}`, // Top-right arc
        `V ${totalHeight - r}`, // Vertical line down
        `A ${r} ${r} 0 0 1 ${width - r} ${totalHeight}`, // Bottom-right arc
        `H ${r}`, // Horizontal line left
        `A ${r} ${r} 0 0 1 0 ${totalHeight - r}`, // Bottom-left arc
        `V ${caretHeight + r}`, // Vertical line up
        `A ${r} ${r} 0 0 1 ${r} ${caretHeight}`, // Top-left arc
        'Z', // Close path
    ].join(' ')

    return pathData
}
